// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewport-container {\r\n  float: left;\r\n  position: relative;\r\n  border: var(--viewport-border-thickness) solid var(--ui-border-color);\r\n}\r\n\r\n.viewport-container.active {\r\n  border: var(--viewport-border-thickness) solid var(--active-color);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
